var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2385.7 1919.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1513.8 528.7h72.8L1794 321.3l10.2-88c-385.9-340.6-975-303.9-1315.6 82C393.9 422.5 325.2 550 287.8 688c23.1-9.5 48.7-11 72.8-4.4l414.7-68.4s21.1-34.9 32-32.7c184.5-202.6 495-226.2 708-53.8h-1.5z",
    fill: "#ea4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2089.4 688c-47.7-175.5-145.5-333.3-281.6-454l-291 291c122.9 100.4 192.9 251.7 189.9 410.4v51.7c143.1 0 259 116 259 259 0 143.1-116 259-259 259h-518.1l-51.7 52.4v310.7l51.7 51.7h518.1c297 2.3 560.5-190.2 648.7-473.8 88-283.7-20-591.7-266-758.1z",
    fill: "#4285f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M669.8 1917h518.1v-414.7H669.8c-36.9 0-73.4-7.9-107-23.3l-72.8 22.5-208.8 207.4-18.2 72.8c117.1 88.4 260 135.9 406.8 135.3z",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M669.8 571.6c-287.8 1.7-542.7 186-634.5 458.7-91.8 272.7-.3 573.7 227.8 749.1l300.5-300.5c-130.4-58.9-188.3-212.3-129.4-342.7 58.9-130.4 212.3-188.3 342.7-129.4 57.4 26 103.4 72 129.4 129.4l300.5-300.5c-127.9-167.1-326.6-264.8-537-264.1z",
    fill: "#fbbc05"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleCloud);
export default __webpack_public_path__ + "static/media/googleCloud.fd4df7157f1ecc61c0d03f421cbf092e.svg";
export { ForwardRef as ReactComponent };